import React, {Fragment, useContext, useState, useEffect} from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import parse from "html-react-parser";
import {isEmpty} from "../Utils";
import {MyContext} from "../../contexts/MyContext";
import { getTranslations } from "../../actions/translations.action";

const NavBarMobileHome = (props) => {
    const [open, setOpen]=useState(false);
    const dispatch = useDispatch();
    const setTypeMenu = props.setTypeMenu;
    const translationsReducer = useSelector(
        (state) => state.langReducer.translationsReducer
    );
    const settings = useSelector((state) => state.settingReducer.getSettingReducer.config);
    const translations = translationsReducer.translate;
    const { rootState, logoutUser } = useContext(MyContext);
    const { isAuth, theUser } = rootState;
	const [language, setLanguage] = useState("EN");
	const [styles, setStyles] = useState({});

    useEffect(() => {
        if (settings?.menu_text_color) {
            setStyles((prevState) => ({...prevState, color: settings.menu_text_color}));
        }
    }, [settings]);

	useEffect(() => {
		dispatch(getTranslations(language));
		// eslint-disable-next-line
	}, [language]);


    return (
        <Fragment>
            {isAuth ? (
                <ul className="menu-account-block" style={styles}>
                    <li className="flex-between"
                        onClick={() =>
                            setTypeMenu("account")
                        }
                    >

						<span>
							<img
                                className="onClick"
                                src={!isEmpty(theUser.img.avatar) ? theUser.img.avatar : "/img/icons/user.svg"}
                                alt="account"
                                width="30"
                            />
                            {theUser.username}
						</span>

                        <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.05273 13.5577C1.346 13.5577 1.5791 13.4524 1.78213 13.2569L7.54961 7.6248C7.80527 7.36914 7.92559 7.10596 7.93311 6.78262C7.93311 6.45928 7.81279 6.18857 7.54961 5.94043L1.78213 0.300781C1.5791 0.105273 1.33848 0 1.05273 0C0.466211 0 0 0.466211 0 1.04521C0 1.33096 0.120313 1.60166 0.330859 1.81221L5.44414 6.78262L0.330859 11.7455C0.120313 11.9561 0 12.2268 0 12.5125C0 13.0915 0.466211 13.5577 1.05273 13.5577Z" fill={settings?.menu_text_color ? settings.menu_text_color : "whitqqqe"}/>
                        </svg>
                    </li>

                    <li className="logout"
                        onClick={() => logoutUser()}
                    >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 10L13.3333 4.94465V7.77777H5.55556V12.2222H13.3333V15.0165L20 10ZM2.22222 2.22223H11.1111V0H2.22222C1 0 0 1.00001 0 2.22223V17.7778C0 19 1 20 2.22222 20H11.1111V17.7778H2.22222V2.22223Z" fill={settings?.menu_text_color ? settings.menu_text_color : "white"}/>
                        </svg>
                        <span>
                            {translations && !isEmpty(translations["logout"])
                                ? translations["logout"]
                                : "logout"
                            }
                        </span>
                    </li>
                </ul>
            ) : (
                <ul className="menu-account-block" style={styles}>
                    <NavLink
                        to="/account/login" id="login-button"
                        onClick={() =>
                            document.querySelector(".main-header").classList.remove("menu-open")
                        }
                    >
                        <li className="flex-between" style={styles}>
							<span>
								{translations && !isEmpty(translations["button_login"])
                                    ? translations["button_login"]
                                    : "Login"
                                }
							</span>
                            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.05273 13.5577C1.346 13.5577 1.5791 13.4524 1.78213 13.2569L7.54961 7.6248C7.80527 7.36914 7.92559 7.10596 7.93311 6.78262C7.93311 6.45928 7.81279 6.18857 7.54961 5.94043L1.78213 0.300781C1.5791 0.105273 1.33848 0 1.05273 0C0.466211 0 0 0.466211 0 1.04521C0 1.33096 0.120313 1.60166 0.330859 1.81221L5.44414 6.78262L0.330859 11.7455C0.120313 11.9561 0 12.2268 0 12.5125C0 13.0915 0.466211 13.5577 1.05273 13.5577Z" fill={settings?.menu_text_color ? settings.menu_text_color : "white"}/>
                            </svg>

                        </li>
                    </NavLink>
                    <NavLink
                        to="/account/register" id="register-button"
                        onClick={() =>
                            document.querySelector(".main-header").classList.remove("menu-open")
                        }
                    >
                        <li className="flex-between" style={styles}>
							<span>
								{translations && !isEmpty(translations["button_register"])
                                    ? translations["button_register"]
                                    : "register"
                                }
							</span>
                            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.05273 13.5577C1.346 13.5577 1.5791 13.4524 1.78213 13.2569L7.54961 7.6248C7.80527 7.36914 7.92559 7.10596 7.93311 6.78262C7.93311 6.45928 7.81279 6.18857 7.54961 5.94043L1.78213 0.300781C1.5791 0.105273 1.33848 0 1.05273 0C0.466211 0 0 0.466211 0 1.04521C0 1.33096 0.120313 1.60166 0.330859 1.81221L5.44414 6.78262L0.330859 11.7455C0.120313 11.9561 0 12.2268 0 12.5125C0 13.0915 0.466211 13.5577 1.05273 13.5577Z" fill={settings?.menu_text_color ? settings.menu_text_color : "white"}/>
                            </svg>
                        </li>
                    </NavLink>
                </ul>
            )}



            <ul className="menu-block">
                <NavLink
                    exact
                    to="/"
                    onClick={() =>
                        document.querySelector(".main-header").classList.remove("menu-open")
                    }
                >
                    <li style={styles}>
                        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M5.59472 15.0257V12.5722C5.59471 11.9505 6.12688 11.4454 6.78605 11.4415H9.20641C9.86853 11.4415 10.4053 11.9477 10.4053 12.5722V15.0186C10.4053 15.5578 10.8665 15.9961 11.4383 16H13.0895C13.8607 16.0019 14.6011 15.7142 15.1471 15.2006C15.6931 14.6869 16 13.9894 16 13.262V6.29268C16 5.70511 15.7238 5.14777 15.246 4.7708L9.63619 0.539415C8.65559 -0.200702 7.25505 -0.176793 6.30349 0.596307L0.814326 4.7708C0.313887 5.13666 0.0147809 5.69565 0 6.29268V13.2549C0 14.771 1.30306 16 2.91046 16H4.52403C4.7993 16.0019 5.06399 15.9001 5.25935 15.7171C5.4547 15.5342 5.56457 15.2853 5.56456 15.0257H5.59472Z' fill={settings?.menu_text_color ? settings.menu_text_color : "white"}/></svg>
                        <span>
							{translations && !isEmpty(translations["menu_home"])
                                ? translations["menu_home"]
                                : "Home"
                            }
						</span>
                    </li>
                </NavLink>
                <NavLink
                    exact
                    to="/discipline"
                    onClick={() =>
                        document.querySelector(".main-header").classList.remove("menu-open")
                    }
                >
                    <li style={styles}>
                        <svg width='16' height='16' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16.03 16'><rect width='6.77' height='6.83' rx='2.03' ry='2.03' fill={settings?.menu_text_color ? settings.menu_text_color : "white"}/><path d='M4.73,9.17H2a2,2,0,0,0-2,2.05V14A2,2,0,0,0,2,16H4.73a2,2,0,0,0,2-2.05V11.22A2,2,0,0,0,4.73,9.17Z' transform='translate(0.01 0)' fill={settings?.menu_text_color ? settings.menu_text_color : "white"}/><path d='M14,9.17h-2.7a2,2,0,0,0-2,2.05V14a2,2,0,0,0,2,2.05H14A2,2,0,0,0,16,14V11.22A2,2,0,0,0,14,9.17Z' transform='translate(0.01 0)' fill={settings?.menu_text_color ? settings.menu_text_color : "white"}/><rect x='9.2' width='6.83' height='6.83' rx='2.14' ry='2.14' fill={settings?.menu_text_color ? settings.menu_text_color : "white"}/></svg>
                        <span>
							{translations && !isEmpty(translations["menu_disciplines"])
                                ? translations["menu_disciplines"]
                                : "Disciplines"
                            }
						</span>
                    </li>
                </NavLink>
                <NavLink
                    exact
                    to="/directs"
                    onClick={() =>
                        document.querySelector(".main-header").classList.remove("menu-open")
                    }
                >
                    <li style={styles}>
                        <svg width='16' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12.7286 8.81416L1.42357 15.8599C0.982635 16.1347 0.406742 15.9929 0.137279 15.5432C0.0475027 15.3934 0 15.2212 0 15.0456V0.954235C0 0.427225 0.418914 0 0.935669 0C1.10784 0 1.27667 0.0484453 1.42357 0.140003L12.7286 7.1857C13.1695 7.46051 13.3085 8.04783 13.0391 8.49752C12.9617 8.62669 12.8552 8.73523 12.7286 8.81416Z' fill={settings?.menu_text_color ? settings.menu_text_color : "white"}/></svg>
                        <span>
							{translations && !isEmpty(translations["menu_directs"])
                                ? translations["menu_directs"]
                                : "Directs"
                            }
						</span>

                    </li>
                </NavLink>
            </ul>

            <ul className="menu-block">
                {isAuth && (
                    <li
                        onClick={() => setTypeMenu("preference")}
                        style={styles}
                    >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.15663 20H10.8434C11.4643 20 11.9277 19.62 12.0575 19.0269L12.5116 17.127C12.7896 17.0343 13.0584 16.9231 13.2994 16.8119L14.9583 17.8313C15.468 18.1464 16.0704 18.0908 16.4968 17.6738L17.683 16.4875C18.1094 16.0612 18.165 15.431 17.8313 14.9305L16.8211 13.2808C16.9323 13.0306 17.0343 12.7804 17.1177 12.5209L19.0361 12.0667C19.6386 11.937 20 11.4736 20 10.8526V9.1937C20 8.59129 19.6386 8.11863 19.0361 7.98888L17.1362 7.53475C17.0436 7.24745 16.9323 6.98795 16.8397 6.76552L17.8499 5.08804C18.1835 4.56905 18.1372 3.96664 17.6923 3.54032L16.4875 2.35403C16.0612 1.96478 15.5144 1.89064 14.9954 2.17794L13.2994 3.22521C13.0584 3.10473 12.7989 3.00278 12.5209 2.90083L12.0575 0.973123C11.9277 0.379981 11.4643 0 10.8434 0H9.15663C8.53568 0 8.07229 0.379981 7.94254 0.982391L7.48842 2.8823C7.21038 2.98424 6.93234 3.08619 6.69138 3.21594L5.00463 2.17794C4.48563 1.89064 3.93883 1.95551 3.50324 2.35403L2.30769 3.54032C1.86284 3.96664 1.8165 4.56905 2.15014 5.08804L3.16033 6.76552C3.06766 6.98795 2.95644 7.24745 2.86376 7.53475L0.963855 7.98888C0.370714 8.11863 0 8.59129 0 9.1937V10.8526C0 11.4736 0.370714 11.937 0.963855 12.0667L2.8823 12.5209C2.96571 12.7804 3.06766 13.0306 3.17887 13.2808L2.16867 14.9305C1.83503 15.431 1.89064 16.0612 2.31696 16.4875L3.50324 17.6738C3.92956 18.0908 4.53197 18.1464 5.04171 17.8313L6.70065 16.8119C6.94161 16.9231 7.21038 17.0343 7.48842 17.127L7.94254 19.0269C8.07229 19.62 8.53568 20 9.15663 20ZM10 13.2159C8.22984 13.2159 6.78406 11.7702 6.78406 9.99073C6.78406 8.23911 8.22984 6.78406 10 6.78406C11.7702 6.78406 13.2159 8.23911 13.2159 9.99073C13.2159 11.7702 11.7702 13.2159 10 13.2159Z" fill={settings?.menu_text_color ? settings.menu_text_color : "white"}/>
                        </svg>


                        <span>
                            {translations && !isEmpty(translations["menu_settings"])
                                ? translations["menu_settings"]
                                : "Settings"
                            }
                        </span>
                    </li>
                )}
                <NavLink
                    exact
                    to="/"
                    onClick={() =>
                        document.querySelector(".main-header").classList.remove("menu-open")
                    }
                >
                    <li style={styles}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.0005 0C4.47685 0 0 4.47684 0 9.99947C0 15.5231 4.47685 20 10.0005 20C15.5221 20 20 15.5231 20 9.99947C20 4.47684 15.5221 0 10.0005 0ZM11.4005 3.17461C12.4037 3.17461 12.6984 3.82363 12.6984 4.56589C12.6984 5.49221 12.0339 6.34921 10.899 6.34921C9.94943 6.34921 9.49716 5.81732 9.52502 4.93641C9.52502 4.19416 10.0813 3.17461 11.4005 3.17461ZM8.3571 15.873C7.62613 15.873 7.09275 15.4463 7.60329 13.5759L8.44048 10.2574C8.58554 9.72648 8.60952 9.51366 8.44048 9.51366C8.22233 9.51366 7.27321 9.88006 6.71355 10.2421L6.34921 9.66834C8.12525 8.24333 10.1674 7.40741 11.0412 7.40741C11.7721 7.40741 11.8932 8.23674 11.5289 9.51366L10.5694 13.0022C10.3993 13.6187 10.4724 13.8315 10.6425 13.8315C10.8618 13.8315 11.5791 13.577 12.285 13.0427L12.6984 13.5759C10.9703 15.2346 9.08694 15.873 8.3571 15.873Z" fill={settings?.menu_text_color ? settings.menu_text_color : "white"}/>
                        </svg>

                        <span>
                            {translations && !isEmpty(translations["contact"])
                                ? translations["contact"]
                                : "Contact"
                            }
                        </span>
                    </li>
                </NavLink>
                <NavLink
                    exact
                    to="/"
                    onClick={() =>
                        document.querySelector(".main-header").classList.remove("menu-open")
                    }
                >
                    <li style={styles}>
                        <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M15.7857 0H1.21429C0.542786 0 0 0.496673 0 1.11112V18.8889C0 19.5022 0.542786 20 1.21429 20H15.7857C16.4572 20 17 19.5022 17 18.8889V1.11112C17 0.497785 16.4572 0 15.7857 0ZM12.1429 15.5556H4.85714V13.3333H12.1429V15.5556ZM12.1429 11.1111H4.85714V8.88888H12.1429V11.1111ZM12.1429 6.66666H4.85714V4.44444H12.1429V6.66666Z" fill={settings?.menu_text_color ? settings.menu_text_color : "white"}/>
                        </svg>

                        <span>
                            {translations && !isEmpty(translations["privacy_policy"])
                                ? translations["privacy_policy"]
                                : "Privacy policy"
                            }
                        </span>
                    </li>
                </NavLink>
                <li className={open ? "lang-open": "lang-closed"}>
                    <div className="lang-menu" onClick={() => setOpen(!open)}>
                        <span style={styles}>
                            <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.7527 8.36747C19.1287 6.68296 17.3867 5.67738 15.0917 5.67738C15.0017 5.67738 14.9157 5.67935 14.8297 5.6833L14.8137 3.64748C14.8137 3.64748 18.2237 3.06722 18.3387 3.04847C18.4537 3.02972 18.4717 2.93104 18.4477 2.82051C18.4247 2.71098 18.2807 1.94915 18.2597 1.85737C18.2327 1.7281 18.1577 1.73204 18.0527 1.74981C17.9487 1.76757 14.8027 2.20473 14.8027 2.20473C14.8027 2.20473 14.7907 0.277459 14.7897 0.154105C14.7887 0.030752 14.7207 -0.00181368 14.5957 7.66557e-05C14.4708 0.00213366 13.6758 0.0139753 13.5708 0.015949C13.4658 0.0179226 13.4068 0.0643034 13.4088 0.161999C13.4108 0.260682 13.4418 2.43861 13.4418 2.43861C13.4418 2.43861 10.3808 2.95867 10.2978 2.97446C10.2138 2.98827 10.1278 3.02676 10.1468 3.11558C10.1658 3.20439 10.3368 4.19516 10.3548 4.27214C10.3728 4.35108 10.4268 4.39944 10.5428 4.37773C10.6578 4.35898 13.4668 3.88037 13.4668 3.88037L13.5018 5.87179C12.4248 6.14908 11.7008 6.68493 11.2458 7.15762C10.4778 7.95399 10.0388 9.01977 10.0388 10.0816C10.0388 11.6467 11.0098 12.5773 12.3668 12.7411C15.5287 13.123 17.4857 9.7214 18.1357 8.0882C19.2327 9.57436 18.3917 12.3848 16.0417 13.9894C15.9987 14.018 15.9437 14.1167 16.0087 14.1937C16.0737 14.2707 16.5497 14.847 16.6277 14.9397C16.7077 15.0345 16.8337 14.998 16.8837 14.9624C19.3937 13.2552 20.5447 10.5069 19.7527 8.36747ZM12.3668 11.5135C11.4008 11.3941 11.4228 10.6115 11.4228 10.0796C11.4228 9.3168 11.7498 8.52043 12.2988 7.95202C12.6338 7.60268 13.0488 7.3392 13.5278 7.16354L13.6098 11.3842C13.2248 11.5135 12.8108 11.5668 12.3668 11.5135ZM14.7937 10.9678L14.8397 6.91289C14.9237 6.90894 15.0057 6.90302 15.0917 6.90302C15.8647 6.90302 16.5857 7.04611 16.9767 7.25926C17.3677 7.47341 15.9537 9.93653 14.7937 10.9678ZM5.84385 3.40077C5.81385 3.30801 5.74085 3.25768 5.64785 3.25768H3.69787C3.60487 3.25768 3.53287 3.30801 3.50387 3.39978C3.09188 4.68167 0.0239138 14.245 0.00791393 14.2953C-0.00908588 14.3457 -0.00308595 14.3703 0.0699132 14.3703H1.80289C1.87789 14.3703 1.90189 14.3476 1.91689 14.2993C1.93189 14.249 2.92488 11.025 2.92488 11.025H6.42084C6.42084 11.025 7.41283 14.25 7.42883 14.2993C7.44483 14.3476 7.46783 14.3703 7.54183 14.3703H9.27581C9.34781 14.3703 9.35381 14.3457 9.33781 14.2953C9.32381 14.246 6.25484 4.68266 5.84385 3.40077ZM3.22588 9.63555L4.67286 4.4547L6.11985 9.63555H3.22588Z" fill={settings?.menu_text_color ? settings.menu_text_color : "white"}/></svg>

                            {translations && !isEmpty(translations["languages"])
                                ? translations["languages"]
                                : "Languages"
                            }

                        </span>
                        <svg id="arrow-menu"  width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.05273 13.5577C1.346 13.5577 1.5791 13.4524 1.78213 13.2569L7.54961 7.6248C7.80527 7.36914 7.92559 7.10596 7.93311 6.78262C7.93311 6.45928 7.81279 6.18857 7.54961 5.94043L1.78213 0.300781C1.5791 0.105273 1.33848 0 1.05273 0C0.466211 0 0 0.466211 0 1.04521C0 1.33096 0.120313 1.60166 0.330859 1.81221L5.44414 6.78262L0.330859 11.7455C0.120313 11.9561 0 12.2268 0 12.5125C0 13.0915 0.466211 13.5577 1.05273 13.5577Z" fill={settings?.menu_text_color ? settings.menu_text_color : "white"}/>
                        </svg>
                        <ul className="language-sub" style={styles}>
                            {settings?.available_languages.includes("en") && (
                                <li
                                    className="d-flex"
                                    onClick={(e) => setLanguage("EN")}
                                >
                                    <img
                                        src="/img/icons/flag_of_en.svg"
                                        alt="flag english"
                                        width="20"
                                        height="20"
                                    />
                                    <span>English</span>
                                </li>
                            )}
                            {settings?.available_languages.includes("fr") && (
                                <li
                                    className="d-flex"
                                    onClick={(e) => setLanguage("FR")}
                                >
                                    <img
                                        src="/img/icons/flag_of_fr.svg"
                                        alt="flag france"
                                        width="20"
                                        height="20"
                                    />
                                    <span>Français</span>
                                </li>
                            )}
                            {settings?.available_languages.includes("es") && (
                                <li
                                    className="d-flex"
                                    onClick={(e) => setLanguage("ES")}
                                >
                                    <img
                                        src="/img/icons/flag_of_es.svg"
                                        alt="flag spain"
                                        width="20"
                                        height="20"
                                    />
                                    <span>Español</span>
                                </li>
                            )}
                            {settings?.available_languages.includes("pt") && (
                                <li
                                    className="d-flex"
                                    onClick={(e) => setLanguage("PT")}
                                >
                                    <img
                                        src="/img/icons/flag_of_pt.svg"
                                        alt="flag Português"
                                        width="20"
                                        height="20"
                                    />
                                    <span>Português</span>
                                </li>
                            )}
                            {settings?.available_languages.includes("it") && (
                                <li
                                    className="d-flex"
                                    onClick={(e) => setLanguage("IT")}
                                >
                                    <img
                                        src="/img/icons/flag_of_it.svg"
                                        alt="flag italiano"
                                        width="20"
                                        height="20"
                                    />
                                    <span>Italiano</span>
                                </li>
                            )}
                            {settings?.available_languages.includes("de") && (
                                <li
                                    className="d-flex"
                                    onClick={(e) => setLanguage("DE")}
                                >
                                    <img
                                        src="/img/icons/flag_of_de.svg"
                                        alt="flag Deutsch"
                                        width="20"
                                        height="20"
                                    />
                                    <span>Deutsch</span>
                                </li>
                            )}
                            {settings?.available_languages.includes("ar") && (
                                <li
                                    className="d-flex"
                                    onClick={(e) => setLanguage("AR")}
                                >
                                    <img
                                        src="/img/icons/flag_of_ar.svg"
                                        alt="flag arabian"
                                        width="20"
                                        height="20"
                                    />
                                    <span>عربي</span>
                                </li>
                            )}
                        </ul>
                    </div>
                </li>
            </ul>

            <div className="socials">
                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.6">
                        <path d="M21.0357 40.6696C32.1011 40.6696 41.0714 31.6993 41.0714 20.6339C41.0714 9.56844 32.1011 0.598145 21.0357 0.598145C9.97029 0.598145 1 9.56844 1 20.6339C1 31.6993 9.97029 40.6696 21.0357 40.6696Z" stroke="white"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M27.9331 17.1518C27.9402 17.3141 27.9429 17.48 27.9429 17.6468C27.9429 22.7419 24.2641 28.6146 17.5371 28.6146C15.4693 28.6146 13.5478 27.976 11.9287 26.881C12.2168 26.9168 12.5068 26.9357 12.802 26.9357C14.5166 26.9357 16.091 26.3213 17.3417 25.2872C15.744 25.254 14.3926 24.1419 13.9278 22.6092C14.1517 22.6549 14.3801 22.6809 14.6156 22.6809C14.9501 22.6809 15.2739 22.6316 15.579 22.5446C13.9064 22.1903 12.645 20.6307 12.645 18.7652V18.7168C13.1383 19.0065 13.7012 19.1796 14.3025 19.1984C13.3212 18.5087 12.6763 17.3284 12.6763 15.9903C12.6763 15.2836 12.8564 14.6235 13.1696 14.0522C14.9733 16.384 17.6709 17.9186 20.7074 18.0809C20.6459 17.7957 20.6129 17.5042 20.6129 17.2002C20.6129 15.0728 22.2525 13.3481 24.2721 13.3481C25.3247 13.3481 26.2757 13.8172 26.9411 14.5643C27.7734 14.3903 28.5566 14.0719 29.2631 13.6298C28.992 14.5293 28.4103 15.2836 27.6548 15.7607C28.3952 15.6683 29.1026 15.4603 29.7573 15.1535C29.2658 15.9284 28.6476 16.6083 27.9331 17.1518Z" fill="white"/>
                    </g>
                </svg>

                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.6">
                        <path d="M21.1072 40.6696C32.1727 40.6696 41.143 31.6993 41.143 20.6339C41.143 9.56844 32.1727 0.598145 21.1072 0.598145C10.0418 0.598145 1.07153 9.56844 1.07153 20.6339C1.07153 31.6993 10.0418 40.6696 21.1072 40.6696Z" stroke="white"/>
                        <path d="M16.1351 28.8301V16.5405H12.2305V28.8301H16.1354H16.1351ZM14.1835 14.8628C15.5448 14.8628 16.3923 13.919 16.3923 12.7397C16.3668 11.5336 15.5448 10.6162 14.2094 10.6162C12.873 10.6162 12.0002 11.5336 12.0002 12.7397C12.0002 13.919 12.8474 14.8628 14.1579 14.8628H14.1832H14.1835ZM18.2962 28.8301H22.2004V21.9678C22.2004 21.6009 22.226 21.2332 22.329 20.9712C22.6112 20.237 23.2536 19.4771 24.3325 19.4771C25.745 19.4771 26.3103 20.6039 26.3103 22.2562V28.8301H30.2145V21.7837C30.2145 18.0089 28.2885 16.2524 25.7197 16.2524C23.6136 16.2524 22.6886 17.4839 22.1748 18.3227H22.2007V16.5408H18.2965C18.3474 17.6938 18.2962 28.8305 18.2962 28.8305V28.8301Z" fill="white"/>
                    </g>
                </svg>

                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.6">
                        <path d="M21.1785 40.6696C32.244 40.6696 41.2143 31.6993 41.2143 20.6339C41.2143 9.56844 32.244 0.598145 21.1785 0.598145C10.1131 0.598145 1.14282 9.56844 1.14282 20.6339C1.14282 31.6993 10.1131 40.6696 21.1785 40.6696Z" stroke="white"/>
                        <path d="M24.6019 12.437H17.6693C15.0593 12.437 12.9392 14.5571 12.9392 17.1671V24.0951C12.9392 26.7097 15.0593 28.8297 17.6693 28.8297H24.5973C27.2119 28.8297 29.3274 26.7097 29.3274 24.0997V17.1671C29.3319 14.5571 27.2119 12.437 24.6019 12.437ZM27.8209 24.2187C27.8209 25.9541 26.4151 27.3599 24.6797 27.3599H17.5914C15.856 27.3599 14.4503 25.9541 14.4503 24.2187V17.1305C14.4503 15.395 15.856 13.9893 17.5914 13.9893H24.6843C26.4197 13.9893 27.8254 15.395 27.8254 17.1305V24.2187H27.8209Z" fill="white"/>
                        <path d="M21.1355 16.4209C18.7864 16.4209 16.8816 18.3258 16.8816 20.6748C16.8816 23.0238 18.7864 24.9286 21.1355 24.9286C23.4845 24.9286 25.3893 23.0238 25.3893 20.6748C25.3893 18.3258 23.4845 16.4209 21.1355 16.4209ZM21.1355 23.4313C19.6107 23.4313 18.3789 22.195 18.3789 20.6748C18.3789 19.15 19.6152 17.9182 21.1355 17.9182C22.6603 17.9182 23.892 19.1545 23.892 20.6748C23.892 22.1996 22.6603 23.4313 21.1355 23.4313Z" fill="white"/>
                        <path d="M25.5313 17.2496C26.0775 17.2496 26.5204 16.8068 26.5204 16.2605C26.5204 15.7143 26.0775 15.2715 25.5313 15.2715C24.9851 15.2715 24.5422 15.7143 24.5422 16.2605C24.5422 16.8068 24.9851 17.2496 25.5313 17.2496Z" fill="white"/>
                    </g>
                </svg>

                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.6">
                        <path d="M21.2501 40.6696C32.3155 40.6696 41.2858 31.6993 41.2858 20.6339C41.2858 9.56844 32.3155 0.598145 21.2501 0.598145C10.1847 0.598145 1.21436 9.56844 1.21436 20.6339C1.21436 31.6993 10.1847 40.6696 21.2501 40.6696Z" stroke="white"/>
                        <g clipPath="url(#clip0_3107_2645)">
                            <path fillRule="evenodd" clipRule="evenodd" d="M29.2058 15.0671C30.019 15.2812 30.6601 15.9083 30.8791 16.7036C31.2856 18.1565 31.27 21.1847 31.27 21.1847C31.27 21.1847 31.27 24.1977 30.8791 25.6506C30.6601 26.4459 30.019 27.073 29.2058 27.2871C27.7202 27.6694 21.7778 27.6694 21.7778 27.6694C21.7778 27.6694 15.8511 27.6694 14.3498 27.2718C13.5367 27.0577 12.8955 26.4306 12.6766 25.6353C12.2856 24.1977 12.2856 21.1694 12.2856 21.1694C12.2856 21.1694 12.2856 18.1565 12.6766 16.7036C12.8955 15.9083 13.5523 15.2659 14.3498 15.0518C15.8354 14.6694 21.7778 14.6694 21.7778 14.6694C21.7778 14.6694 27.7202 14.6694 29.2058 15.0671ZM24.8272 21.1693L19.8856 23.9528V18.3857L24.8272 21.1693Z" fill="white"/>
                        </g>
                    </g>
                    <defs>
                        <clipPath id="clip0_3107_2645">
                            <rect width="19" height="13" fill="white" transform="translate(12.2856 14.6694)"/>
                        </clipPath>
                    </defs>
                </svg>

                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.6">
                        <path d="M21.3214 40.6696C32.3868 40.6696 41.3571 31.6993 41.3571 20.6339C41.3571 9.56844 32.3868 0.598145 21.3214 0.598145C10.2559 0.598145 1.28564 9.56844 1.28564 20.6339C1.28564 31.6993 10.2559 40.6696 21.3214 40.6696Z" stroke="white"/>
                        <path d="M28.2856 9.59814V29.4562H24.2163V27.9358C23.144 29.0118 21.7008 29.5981 20.0131 29.5981C16.3222 29.5981 13.2856 26.3468 13.2856 22.2689C13.2856 18.191 16.535 14.8943 20.0131 14.8943C21.7008 14.8943 23.144 15.5134 24.2163 16.6097V10.441L28.2856 9.59814ZM20.9356 25.7405C21.8452 25.7397 22.7173 25.366 23.3605 24.7014C24.0037 24.0369 24.3653 23.1358 24.3661 22.1959C24.3654 21.2561 24.0038 20.3549 23.3606 19.6902C22.7174 19.0256 21.8453 18.6518 20.9356 18.651C20.026 18.6518 19.1538 19.0256 18.5106 19.6902C17.8675 20.3549 17.5058 21.2561 17.5051 22.1959C17.5059 23.1358 17.8676 24.0369 18.5108 24.7014C19.1539 25.366 20.026 25.7397 20.9356 25.7405Z" fill="white"/>
                    </g>
                </svg>
                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.6">
                        <path d="M21.3929 40.6696C32.4583 40.6696 41.4286 31.6993 41.4286 20.6339C41.4286 9.56844 32.4583 0.598145 21.3929 0.598145C10.3275 0.598145 1.35718 9.56844 1.35718 20.6339C1.35718 31.6993 10.3275 40.6696 21.3929 40.6696Z" stroke="white"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M25.7841 17.6644H23.0491V15.9891C23.0491 15.3604 23.4951 15.2133 23.8091 15.2133H25.7395V12.4474L23.0812 12.4375C20.1285 12.4375 19.4567 14.5012 19.4567 15.8214V17.6644H17.7502V20.5156H19.4567V28.5811H23.0491V20.5156H25.4701L25.7841 17.6644Z" fill="white"/>
                    </g>
                </svg>
            </div>
            <div className="copyright">
                <p>
                    {translations && !isEmpty(translations["footer_copyright"])
                        ? parse(translations["footer_copyright"])
                        : parse("Copyright © 2021 FFGYM <br /> All rights reserved.")
                    }
                </p>
            </div>
        </Fragment>
    );
};

export default NavBarMobileHome;
